import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.assign";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { readLocalStorage, writeLocalStorage } from 'redux/saga/helpers/local-storage';
import { ADD_BANNER, REMOVE_BANNERS } from './Banners.reducer';
var LS_KEY = 'suppressedReactBanners';
export function bannerMiddleware() {
  var onClient = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __CLIENT__;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    read: readLocalStorage,
    write: writeLocalStorage
  },
      read = _ref.read,
      write = _ref.write;

  return function (_ref2) {
    var dispatch = _ref2.dispatch,
        getState = _ref2.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState);
        }

        if (action.type === ADD_BANNER && action.data.options.suppressible) {
          if (onClient) {
            var suppressible = action.data.options.suppressible;
            var data = read(LS_KEY, {});

            if (!data[action.data.id]) {
              return next(action);
            } else if (typeof suppressible === 'number' && Date.now() - suppressible > data[action.data.id]) {
              return next(action);
            }
          }
        } else if (action.type === REMOVE_BANNERS && onClient) {
          var banners = getState().banners;
          write(LS_KEY, action.data.map(function (bannerId) {
            return banners.find(function (banner) {
              return banner.id === bannerId;
            });
          }).filter(function (x) {
            return x && x.suppressible;
          }).map(function (banner) {
            return banner.id;
          }).reduce(function (acc, bannerId) {
            return Object.assign(acc, _defineProperty({}, bannerId, Date.now()));
          }, read(LS_KEY, {})));
          next(action);
        } else {
          next(action);
        }
      };
    };
  };
}